import { Pipe, PipeTransform } from '@angular/core';
import { AssignmentAction } from '@apaq/orgkit-js';
import { AssignmentActionFormatter } from 'src/app/text/assignment-action-formatter';

@Pipe({
  name: 'assignmentAction'
})
export class AssignmentActionPipe implements PipeTransform {

  transform(action: AssignmentAction) {
    return AssignmentActionFormatter.format(action);
  }
}